export default __webpack_public_path__ + "static/granulation-822517036fc32e41b1fd4b7888f2c095.png";